import { AgentModel } from '../types/agent';

export interface AIModelOption {
  value: AgentModel;
  label: string;
  credits: number;
  category?: string;
}

export const AI_MODELS: AIModelOption[] = [
  // 1 crédito
  // { value: 'gemini-2.0-flash-lite', label: 'gemini-2.0-flash-lite', credits: 1, category: 'Google' },
  { value: 'gpt-4.1-nano', label: 'gpt-4.1-nano', credits: 1, category: 'OpenAI' },
  { value: 'gpt-5-nano', label: 'gpt-5-nano', credits: 1, category: 'OpenAI' },
  { value: 'gpt-4o-mini', label: 'gpt-4o-mini', credits: 1, category: 'OpenAI' },
  // { value: 'llama-3.1-70b', label: 'llama-3.1-70b', credits: 1, category: 'Meta' },
  // { value: 'gpt-3.5-turbo-16k', label: 'gpt-3.5-turbo-16k', credits: 1, category: 'OpenAI' },
  // { value: 'deepseek-chat', label: 'deepseek-chat', credits: 1, category: 'DeepSeek' },
  
  // 2 créditos
  { value: 'gpt-4.1-mini', label: 'gpt-4.1-mini', credits: 2, category: 'OpenAI' },
  { value: 'gpt-5-mini', label: 'gpt-5-mini', credits: 2, category: 'OpenAI' },
  // { value: 'gemini-2.0-flash', label: 'gemini-2.0-flash', credits: 2, category: 'Google' },
  
  // 3 créditos
  // { value: 'deepseek-v3', label: 'deepseek-v3', credits: 3, category: 'DeepSeek' },
  
  // 5 créditos
  { value: 'o1-mini', label: '[beta] o1-mini', credits: 5, category: 'OpenAI' },
  
  // 7 créditos
  { value: 'gpt-4.1', label: 'gpt-4.1', credits: 7, category: 'OpenAI' },
  { value: 'gpt-5', label: 'gpt-5', credits: 7, category: 'OpenAI' },
  
  // 10 créditos
  // { value: 'sonnet-3.5', label: 'sonnet-3.5', credits: 10, category: 'Anthropic' },
  // { value: 'sonnet-4.0', label: 'sonnet-4.0', credits: 10, category: 'Anthropic' },
  { value: 'gpt-4o', label: 'gpt-4o', credits: 10, category: 'OpenAI' },
];

// Função para obter modelos agrupados por créditos
export const getModelsByCredits = (): Record<number, AIModelOption[]> => {
  return AI_MODELS.reduce((acc, model) => {
    if (!acc[model.credits]) {
      acc[model.credits] = [];
    }
    acc[model.credits].push(model);
    return acc;
  }, {} as Record<number, AIModelOption[]>);
};

// Função para obter modelos agrupados por categoria
export const getModelsByCategory = (): Record<string, AIModelOption[]> => {
  return AI_MODELS.reduce((acc, model) => {
    const category = model.category || 'Outros';
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(model);
    return acc;
  }, {} as Record<string, AIModelOption[]>);
};

// Função para obter apenas os valores dos modelos (para compatibilidade)
export const getModelValues = (): AgentModel[] => {
  return AI_MODELS.map(model => model.value);
};

// Função para obter um modelo específico
export const getModelOption = (value: AgentModel): AIModelOption | undefined => {
  return AI_MODELS.find(model => model.value === value);
};
